{
  "jsm-live-chat-helpseeker-spotlight.body": [
    {
      "type": 0,
      "value": "You can connect to an agent from this widget. Start the conversation, then ask AI to speak to an agent."
    }
  ],
  "jsm-live-chat-helpseeker-spotlight.close": [
    {
      "type": 0,
      "value": "Close"
    }
  ],
  "jsm-live-chat-helpseeker-spotlight.connect-link": [
    {
      "type": 0,
      "value": "Connect to a human now"
    }
  ],
  "jsm-live-chat-helpseeker-spotlight.title": [
    {
      "type": 0,
      "value": "Human support is available"
    }
  ]
}